import React, { createContext, useContext } from 'react';
export const useNavigationContext = () => useContext(NavigationContext);

export interface NavigationContextType {
  /** Hide the primary (top) navbar entirely */
  hideFirstNavbar?: boolean;
  /** Setter to hide/show the primary (top) navbar */
  setHideFirstNavbar?: (hide: boolean) => void;
  hideSecondNavbar: boolean;
  setHideSecondNavbar: (hide: boolean) => void;
  onSearchClick?: () => void;
  setOnSearchClick?: (cb: (() => void) | undefined) => void;
}

export const NavigationContext = createContext<NavigationContextType>({
  hideFirstNavbar: false,
  setHideFirstNavbar: () => {},
  hideSecondNavbar: false,
  setHideSecondNavbar: () => {},
});

